import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    accategoriesChannel = new Subject();
    detailChannel = new Subject();
    detailLevel = new Subject();
    updateChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchLevel = async (query) => {
        this.detailLevel.next({status: apiResponse.LOADING})
        await this.repository.fetchLevel(query).then((result) => {
            this.detailLevel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailLevel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchCategories = async (query) => {
        this.accategoriesChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCategories(query).then((result) => {
            this.accategoriesChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.accategoriesChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default UpdateBloc